var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"app-alert",class:[
    _vm.alertClass,
    {
      'app-alert--clickable': _vm.clickable,
    },
  ],attrs:{"outlined":_vm.outlined,"dense":_vm.dense,"dismissible":_vm.dismissible,"icon":_vm.resolvedIcon,"close-label":_vm.closeLabel},on:{"click":_vm.handleClick,"input":function($event){return _vm.$emit('input', $event)}}},[_c('div',{staticClass:"d-flex align-center justify-space-between flex-wrap",staticStyle:{"gap":"8px 16px"}},[_c('div',[(_vm.title)?_c('div',{staticClass:"app-alert__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('div',{staticClass:"app-alert__content"},[_vm._t("default")],2)]),_vm._t("actions")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }